<template>
  <div class="notification-container">
    <div
      v-for="notification in notifications"
      :key="notification.id"
      class="notification"
      :data-type="notification.type"
    >
      <div class="notification-content">
        <strong>{{ notification.title }}</strong>
        <p>{{ notification.message }}</p>
      </div>
      <button @click="removeNotification(notification.id)" class="close-button">
        ×
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useNotificationStore } from "@/store/notificationStore";

const store = useNotificationStore();
const notifications = computed(() => store.notifications);

const removeNotification = (id) => {
  store.removeNotification(id);
};
</script>

<style scoped>
.notification-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  width: 300px;
}

.notification {
  background-color: var(--mc-bg-card);
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  margin-bottom: 10px;
  padding: 15px;
  display: flex;
  align-items: flex-start;
  border-left: 4px solid #4caf50;
}

.notification[data-type="access-denied"] {
  border-left-color: #f0ad4e;
}

.notification-content {
  flex-grow: 1;
}

.notification-content strong {
  display: block;
  margin-bottom: 5px;
}

.notification-content p {
  margin: 0;
  font-size: 14px;
}

.close-button {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 0 5px;
}
</style>
